import React, {FC, useCallback, useState, useEffect} from "react";
import {
    AdequacyTypeID, ComponentTypeID,
    IAdequacy,
    IControlMeasureConcern
,

    IProjectFailureMode
} from "../types/types";


import {
    Box,
    Chip,
    Collapse,
    IconButton,
    Table, TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Tooltip
} from "@material-ui/core";
import AdequacySelection from "./adequacy_selection";
import {WarningChip} from "./reasonably_practicable_tests";
import Comments from "./comments";

import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {  useTask } from '../stateManagement/context';



interface IControlMeasureConcernProps {
    control_measure_concern: IControlMeasureConcern
    project_failure_mode:IProjectFailureMode
    updateControlMeasuresConcern: (controlMeasureAssessment: IControlMeasureConcern) => void;
    adequacies: IAdequacy[] 
}



export const ControlConcern= (control_measure_concern: IControlMeasureConcern, name?:string) => {

    let op = control_measure_concern.concern
    if (!op)
         return WarningChip(name?name:"undefined")

    let level = op.level

    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    let alpha = 1
    let label = op.name

    if (level === 1) {

        bcolor = "rgba(251,84,81," + alpha + ")";
        color = "rgb(104,4,0)";
    }
    if (level === 2) {
        bcolor = "rgba(252,236,166," + alpha + ")";
        color = "rgb(152,96,34)";
    }
    if (level === 3) {
        bcolor = "rgba(206,238,208," + alpha + ")";
        color = "rgb(48,104,33)";
    }
    if (level > 3) {
        bcolor = "rgba(206,238,208," + alpha + ")";
        color = "rgb(48,104,33)";
    }

    return (
        <Tooltip title={label}>
            <Chip
                size="small"
                label={name? name : label}
                color="primary"
                style={{backgroundColor: bcolor, color: color}}
            />
        </Tooltip>
    )
}


const SocietalConcern: FC<IControlMeasureConcernProps> = ({control_measure_concern,
                                                                      project_failure_mode,
                                                                      adequacies,
                                                                  updateControlMeasuresConcern}) => {

    const [currentControlMeasureConcern, setCurrentControlMeasureConcern] = useState<IControlMeasureConcern>(control_measure_concern);
    const [justification, setJustification] = useState<string>(control_measure_concern.comment as string);
    const [open, setOpen] = useState(false);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    let tasks = useTask()


    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])


    const graph_data = [
        
        
        
        ["Very High"],["High"],["Moderate"],["Low"]  ]

    const updateAdequacies = <T,>(obj: T,
                                  selected_id: number,
                                  key:keyof T,
                                  setObj:(obj:T) => void) : T => {
        let c = {...obj} as T;
        (c as any)[key] = selected_id
        setObj(c)
        return c
    }

    const updateRisktoSociety = useCallback((selected_id: number ) => {
        let c = updateAdequacies<IControlMeasureConcern>(
            currentControlMeasureConcern,
            selected_id,
            "risk_to_society_id",
            setCurrentControlMeasureConcern)
        updateControlMeasuresConcern(c)

    }, [setCurrentControlMeasureConcern, currentControlMeasureConcern]);

    const updateRiskofConcern = useCallback((selected_id: number ) => {
        let c = updateAdequacies<IControlMeasureConcern>(
            currentControlMeasureConcern,
            selected_id,
            "risk_of_concern_id",
            setCurrentControlMeasureConcern)

            updateControlMeasuresConcern(c)

    }, [setCurrentControlMeasureConcern, currentControlMeasureConcern]);



    return (
        <>
            <TableRow>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>{project_failure_mode.failure_mode?.name}</TableCell>
                <TableCell style={{width: "300px"}}><AdequacySelection adequacies={adequacies}
                                              type_id={AdequacyTypeID.SocietyRisk}
                                              initial_value={(currentControlMeasureConcern.risk_to_society_id || 0).toString()}
                                              updateCallback={updateRisktoSociety}/></TableCell>
                <TableCell><AdequacySelection adequacies={adequacies}
                                              type_id={AdequacyTypeID.SocietyConcern}
                                              initial_value={(currentControlMeasureConcern.risk_of_concern_id || 0).toString()}
                                              updateCallback={updateRiskofConcern}/></TableCell>
                <TableCell>{ControlConcern(control_measure_concern)}</TableCell>
                <TableCell>
                    <TextField
                        style ={{width: '100%'}}
                        inputProps={{ style: { fontSize: "11pt" } }}
                        id="standard-text"
                        value={justification}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        disabled={!write_access}
                        multiline={true}
                        onChange={(event) => {
                            let value = event.target.value
                            setJustification(value)
                            let c = {...currentControlMeasureConcern}
                            c.comment = value
                            setCurrentControlMeasureConcern(c)
                        }

                        }
                        onBlur={(event) => {
                            let value = event.target.value
                            setJustification(value)
                            let c = {...currentControlMeasureConcern}
                            c.comment = value
                            setCurrentControlMeasureConcern(c)
                            updateControlMeasuresConcern(c)
                        }

                        }

                    />
                </TableCell>
                <TableCell>{project_failure_mode.id && <Comments parent_uuid={project_failure_mode.id} type_id={ComponentTypeID.SoceitalConcern}/>}</TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }}colSpan={1}/>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Table>

                        <TableHead>
                                <TableRow>
                                    <TableCell>Significant Risk to Society</TableCell>
                                    <TableCell>Risk has Concern Characteristics (dread, inequity, lack of trust)</TableCell>
                                    <TableCell>Societal concern rating</TableCell>
                                </TableRow>


                            </TableHead>


                            <TableBody>
                                {adequacies.filter( a => a.type_id === AdequacyTypeID.SocietyRisk).map(
                                    (ad, index) => {
                                                return (
                                                    <TableRow>
                                                        <TableCell>{ad.name}  </TableCell>
                                                        {<TableCell>{adequacies.filter( a => a.type_id === AdequacyTypeID.SocietyConcern).filter(a => a.level==ad.level)[0].name}</TableCell>}

                                                        {graph_data[index].map( (e, index_i) => {
                                                            let found = false

                                                            if (index+1 ===  control_measure_concern.concern?.level) {
                                                                found = true
                                                            }

                                                            let style = {}
                                                            if (found) {
                                                                style = ({ ...style, fontWeight:  "bold",
                                                                    outline: "4px solid black",
                                                                    outlineOffset: "-4px"})
                                                            }
                                                            if (e === "") {
                                                                style = ({ ...style,
                                                                    backgroundColor:  "rgb(196,196,196)",
                                                                    color: "#535353"
                                                                })
                                                            }

                                                            if (e === "Moderate" || e === "Low") {
                                                                style = ({ ...style,
                                                                    backgroundColor:  "rgb(206,238,208)",
                                                                    color: "rgb(48,104,33)"
                                                                })
                                                            }
                                                            if (e === "High") {
                                                                style = ({ ...style,
                                                                    backgroundColor:  "rgb(252,236,166)",
                                                                    color: "rgb(152,96,34)"
                                                                })
                                                            }
                                                            if (e === "Very High") {
                                                                style = ({ ...style,
                                                                    backgroundColor:  "rgb(251,84,81)",
                                                                    color: "rgb(104,4,0)"
                                                                })
                                                            }

                                                        return <TableCell style={style}>
                                                            {e}
                                                            </TableCell>
                                                    })}
                                                    </TableRow>
                                        )}
                                )}
                            </TableBody>

                        </Table>

                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

export default SocietalConcern;
